module.exports = __webpack_public_path__ + "static/media/rb.2b900d07.png";